import { Route } from '../../store';
import { TermDepositListStateContainer } from './list/container';

export const expiringTermDepositRoutes: Route[] = [
  {
    path: '/termDeposit/list',
    component: TermDepositListStateContainer,
    protected: true,
    exact: true,
  }
];
